import PropTypes from "prop-types";
import { ListItem } from "components/ui";
import { propOr } from "ramda";
import { formatAddress } from "utils/misc";
import useTranslate from "hooks/use-translate-language";

const Physician = ({ physicians }) => {
  const translate = useTranslate();

  // Only use physicians array
  const physiciansToDisplay = physicians ?? [];

  if (physiciansToDisplay.length === 0) {
    return (
      <div className="profile-panel">
        <h4 className="profile-panel-header">{translate("physician")}</h4>
        <div className="profile-content">
          <p>{translate("noPhysicianInformation")}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="profile-panel">
      <h4 className="profile-panel-header">
        {physiciansToDisplay.length > 1
          ? translate("physicians")
          : translate("physician")}
      </h4>
      <div className="profile-content">
        {physiciansToDisplay.map((physician, index) => (
          <div
            key={physician?.product_line || index}
            style={{
              marginBottom: physiciansToDisplay.length > 1 ? 25 : 0,
              padding: physiciansToDisplay.length > 1 ? "15px" : "0",
              backgroundColor:
                physiciansToDisplay.length > 1 ? "#f8f9fa" : "transparent",
              borderRadius: physiciansToDisplay.length > 1 ? "8px" : "0",
              border:
                physiciansToDisplay.length > 1 ? "1px solid #e9ecef" : "none"
            }}
          >
            {physiciansToDisplay.length > 1 && (
              <h5
                style={{
                  marginBottom: 15,
                  marginTop: 0,
                  color: "#495057",
                  fontWeight: "600",
                  borderBottom: "2px solid #dee2e6",
                  paddingBottom: "8px"
                }}
              >
                {physician.product_line} {translate("physician")}
              </h5>
            )}

            <div
              style={{
                paddingLeft: physiciansToDisplay.length > 1 ? "10px" : "0"
              }}
            >
              <ListItem
                label={translate("name")}
                value={propOr("", "name", physician)}
              />

              <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                <div style={{ flex: "1", minWidth: "200px" }}>
                  <ListItem
                    label={translate("phone")}
                    value={propOr("", "phone", physician)}
                  />
                </div>
                <div style={{ flex: "1", minWidth: "200px" }}>
                  <ListItem
                    label={translate("fax")}
                    value={propOr("", "fax", physician)}
                  />
                </div>
              </div>

              <ListItem label="NPI" value={propOr("", "npi", physician)} />

              <div
                style={{
                  marginTop: "15px",
                  padding: "12px",
                  backgroundColor:
                    physiciansToDisplay.length > 1 ? "#ffffff" : "#f8f9fa",
                  borderRadius: "6px",
                  border: "1px solid #e9ecef"
                }}
              >
                <h6
                  style={{
                    margin: "0 0 10px 0",
                    color: "#6c757d",
                    fontSize: "14px",
                    fontWeight: "600",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px"
                  }}
                >
                  {translate("address")}
                </h6>
                <div style={{ color: "#495057", lineHeight: "1.4" }}>
                  {formatAddress(propOr({}, "address", physician)) ||
                    translate("noAddressProvided")}
                </div>
              </div>

              <ListItem
                label={translate("notes")}
                value={propOr("", "note", physician)}
              />
            </div>

            {physiciansToDisplay.length > 1 &&
              index < physiciansToDisplay.length - 1 && (
                <hr
                  style={{
                    margin: "20px -15px 0 -15px",
                    border: "none",
                    borderTop: "2px solid #dee2e6"
                  }}
                />
              )}
          </div>
        ))}
      </div>
    </div>
  );
};

Physician.propTypes = {
  physicians: PropTypes.arrayOf(
    PropTypes.shape({
      product_line: PropTypes.string,
      name: PropTypes.string,
      phone: PropTypes.string,
      fax: PropTypes.string,
      npi: PropTypes.string,
      address: PropTypes.shape({
        street_address: PropTypes.string,
        street_address2: PropTypes.string,
        city: PropTypes.string,
        state: PropTypes.string,
        zip: PropTypes.string
      })
    })
  )
};

export default Physician;
